import gql from "graphql-tag";

export default gql`
  mutation SubmitOrder(
    $name: String
    $email: String
    $phone: String
    $pfname: String
    $pfname2: String
    $plname: String
    $plname2: String
    $dob: String
    $paddress: String
    $symptoms: String
    $exposed: Boolean
    $vaccinated: Boolean
    $vaccine: VaccineType
    $testType: String
    $reason: String
    $plan: String
    $lab: String
    $type: OrderType
    $orderDoc: String
  ) {
    createOrder(
      name: $name
      email: $email
      phone: $phone
      pfname: $pfname
      pfname2: $pfname2
      plname: $plname
      plname2: $plname2
      dob: $dob
      paddress: $paddress
      symptoms: $symptoms
      exposed: $exposed
      vaccinated: $vaccinated
      vaccine: $vaccine
      testType: $testType
      reason: $reason
      plan: $plan
      lab: $lab
      type: $type
      orderDoc: $orderDoc
    ) {
      id
    }
  }
`;
